// Text Image Modal
import TextImageModal from "../assets/components/text_image_modal.vue"
Vue.component('text-image-modal', TextImageModal)